import { useCallback } from "react";
import {
  bulkSoftDeleteTickets,
  createBulkTickets,
  createTicket,
  getTeamProgress,
  listTickets,
  listTicketsV2,
  refreshTicketOutstanding,
  updateTicketStatus,
  updateTicketStatusSelf,
  uploadBulkTickets,
} from "../service/CallCenterTickets";
import { useAsyncAction } from "./useAsyncAction";

export const useTickets = () => {
  const state = useAsyncAction([]);

  const list = useCallback(
    async (params) => state.run(() => listTicketsV2(params)),
    [state]
  );
  const listLegacy = useCallback(
    async (params) => state.run(() => listTickets(params)),
    [state]
  );
  const create = useCallback(
    async (payload) => state.run(() => createTicket(payload)),
    [state]
  );
  const createBulk = useCallback(
    async (payload) => state.run(() => createBulkTickets(payload)),
    [state]
  );
  const uploadBulk = useCallback(
    async (payload) => state.run(() => uploadBulkTickets(payload)),
    [state]
  );
  const bulkSoftDelete = useCallback(
    async (payload) => state.run(() => bulkSoftDeleteTickets(payload)),
    [state]
  );
  const patchStatus = useCallback(
    async (payload) => state.run(() => updateTicketStatus(payload)),
    [state]
  );
  const patchStatusSelf = useCallback(
    async (payload) => state.run(() => updateTicketStatusSelf(payload)),
    [state]
  );
  const refreshOutstanding = useCallback(
    async (payload) => state.run(() => refreshTicketOutstanding(payload)),
    [state]
  );
  const teamProgress = useCallback(async () => state.run(() => getTeamProgress()), [state]);

  return {
    ...state,
    list,
    listLegacy,
    create,
    createBulk,
    uploadBulk,
    bulkSoftDelete,
    patchStatus,
    patchStatusSelf,
    refreshOutstanding,
    teamProgress,
  };
};
